import * as moment from 'moment';

export class SemanaModel {
  public id: any;
  public tienda: any;
  public tIdDb: any;
  public numSem: number;
  public fecha: any;
  public semana: any;
  public mPorcentaje: MallaPorcentajeModel;
  public ventasSem: number = 0;
  public txtSemana: string = '';
  public horario: HorarioModel;
  public estado: any;
  public observaciones: string[] = [];
  // 0 muestra porcentajes
  // 1 muestra los precios
  // 2 permite la edicion
  public acciones: number = 0;

  constructor(diaIni) {
    this.acciones = 0;
    this.mPorcentaje = new MallaPorcentajeModel(this);

    for (let i = 0; i < 7; i++) {
      let dia = new DiaModel(this);
      dia.txtDia = devolverDiaSem(i);
      this.mPorcentaje.dias.push(dia);
    }

  }

  recalcular() {
    for (let d of this.mPorcentaje.dias) {
      d.inicializar();
      for (let h of d.horas) {
        h.inicializar();
      }
    }
  }

  ajustarSegunHorario() {
    let porDistDia = 0;
    let cantDiasConPre = 0;


    for (let i = 0; i < 7; i++) {
      let horDia = Object.assign({}, this.horario.dias[i]);
      let diaMalla = Object.assign({}, this.mPorcentaje.dias[i]);


      if (horDia.horaInicio != '' || horDia.horaCierre != '') {
        cantDiasConPre++;
        let ti = moment(horDia.horaInicio, 'hh:mm');
        let tc = moment(horDia.horaCierre, 'hh:mm');

        let hi = ti.hour() * 2;
        let hc = tc.hour() * 2;
        let mi = ti.minutes();
        let mc = tc.minutes();

        let cantHoras = hc + ((mc != 0) ? 1 : 0) - hi + ((mi != 0) ? -1 : 0);

        let porDistribuir = 0;


        for (let h = 0; h < 48; h++) {

          if (h < hi) {
            if (diaMalla.horas[h].porcentaje) {
              // presDistribuir += diaMalla.horas[h].precio;
              porDistribuir += diaMalla.horas[h].porcentaje;
              diaMalla.horas[h].precio = 0;
              diaMalla.horas[h].porcentaje = 0;
            }

          } else if (h == hi) {
            if (mi != 0) {
              if (diaMalla.horas[h].porcentaje) {
                porDistribuir += diaMalla.horas[h].porcentaje;
                diaMalla.horas[h].precio = 0;
                diaMalla.horas[h].porcentaje = 0;
              }
            }
          } else if (h > hi && h < hc) {


          } else if (h == hc) {

            if (mc == 0) {

              porDistribuir += diaMalla.horas[h].porcentaje;
              diaMalla.horas[h].precio = 0;
              diaMalla.horas[h].porcentaje = 0;
            }


          } else if (h > hc) {
            porDistribuir += diaMalla.horas[h].porcentaje;
            diaMalla.horas[h].precio = 0;
            diaMalla.horas[h].porcentaje = 0;
          }

        }

        let distPor = 0;

        if (porDistribuir > 0)
          distPor = porDistribuir / cantHoras;


        for (let h = 0; h < 48; h++) {
          if (h >= hi && h < hc) {
            if (mi != 0 && h == hi) {
              continue;
            }

            diaMalla.horas[h].porcentaje += distPor;
            diaMalla.horas[h].precio = diaMalla.horas[h].porcentaje * diaMalla.precio / 100;

          }

          if (mc != 0) {
            if (h == hc) {

              diaMalla.horas[h].porcentaje += distPor;
              diaMalla.horas[h].precio = diaMalla.horas[h].porcentaje * diaMalla.precio / 100;
            }
          }
        }

      } else {
        if (diaMalla.porcentaje > 0) {

          porDistDia += diaMalla.porcentaje;
          diaMalla.porcentaje = 0;
          diaMalla.precio = 0;
          for (let h = 0; h < 48; h++) {
            if (diaMalla.horas[h].porcentaje) {
              diaMalla.horas[h].precio = 0;
              diaMalla.horas[h].porcentaje = 0;
            }

          }
        }
      }

      this.mPorcentaje.dias[i].porcentaje = diaMalla.porcentaje;
      this.mPorcentaje.dias[i].precio = diaMalla.precio;
      for (let hor = 0; hor < diaMalla.horas.length; hor++) {
        this.mPorcentaje.dias[i].horas[hor].porcentaje = diaMalla.horas[hor].porcentaje;
        this.mPorcentaje.dias[i].horas[hor].precio = diaMalla.horas[hor].precio;
      }
      // this.mPorcentaje.dias[i] = diaMalla;
    }



    for (let i = 0; i < 7; i++) {
      let horDia = Object.assign({}, this.horario[i]);
      let diaMalla = Object.assign({}, this.mPorcentaje.dias[i]);
      if (horDia.horaInicio != '' || horDia.horaCierre != '') {
        if (diaMalla.porcentaje > 0) {

          diaMalla.porcentaje += porDistDia / cantDiasConPre;


          // console.log(`${diaMalla.porcentaje} - ${meta}`);
          diaMalla.precio = diaMalla.porcentaje * this.ventasSem / 100;
          diaMalla.horas.map((hor: any) => hor.precio = hor.porcentaje * diaMalla.precio / 100);
        }
      }

      this.mPorcentaje.dias[i].porcentaje = diaMalla.porcentaje;
      this.mPorcentaje.dias[i].precio = diaMalla.precio;

    }

  }

  recalcularPrecio() {
    for (let d of this.mPorcentaje.dias) {
      d.inicializarPrecio();
      for (let h of d.horas) {
        h.inicializarPrecio();
      }
    }
  }

  asignarPrecioXDia(precio: any, fecha: any) {


    let fechaSem = moment(this.fecha);
    let f = moment(fecha);
    for (let d of this.mPorcentaje.dias) {

      // console.log(d);
      // console.log(`fecha1 ${f.toISOString()} - ${fechaSem.toISOString()}`);

      if (fechaSem.isSame(f, 'day')) {

        if (d.porcentaje > 0)
          d.precio = +precio;
        else
          d.precio = 0;
        for (let h of d.horas)
          h.inicializarPrecio();
        break;
      }
      // if(f.toISOString() == fechaSem.toISOString()){
      //   // d.precio = +precio;
      //   // for(let h of d.horas)
      //   //   h.inicializarPrecio();
      //   console.log('entro');
      // }

      fechaSem.add(1, 'd');
    }
  }

  asignarPrecioRangoDia(precio: any, dia1: any, dia2: any) {

    let f1 = moment(dia1, 'YYYY-MM-DD');
    let f2 = moment(dia2, 'YYYY-MM-DD');

    f1.seconds(0).millisecond(0);
    f2.seconds(0).millisecond(0);

    // if (this.tienda == '001')
    //   console.log(`consultando semana de ${this.semana}`);

    let porcentajeMax = 0;

    for (let d of this.mPorcentaje.dias) {

      let fecha = moment(d.fecha).seconds(0).millisecond(0);
      // console.log(`comparando ${fecha.toISOString()} con ${f1.toISOString()} - ${f2.toISOString()}`);
      if (fecha.isBetween(f1, f2, undefined, '[]')) {

        porcentajeMax += d.porcentaje;
      }
    }
    // if (this.tienda == '001')
    //   console.log(`porcentaje maximo ${porcentajeMax}`);
    // console.log(`porcentaje a asignar ${d.porcentaje}`);
    //
    // if (this.tienda == '001')
    //   console.log(this.mPorcentaje.dias);

    for (let d of this.mPorcentaje.dias) {
      let fecha = moment(d.fecha).millisecond(0);

      // console.log(`${d.fecha}`);
      if (fecha.isBetween(f1, f2, undefined, '[]')) {
        // console.log("adentro");
        let por = 0;
        if (porcentajeMax > 0)
          por = d.porcentaje / porcentajeMax;
        else
          d.porcentaje = 0;


        d.precio = por * precio;


        for (let h of d.horas)
          h.inicializarPrecio();

      }
      // else
      //   console.log("afuera")
    }

  }

  recalcularPresupuestoDesdeDias() {
    this.ventasSem = 0;
    for (let d of this.mPorcentaje.dias) {
      this.ventasSem += d.precio;
    }
  }

  agregarVenta(venta: any) {
    if (venta.fecha) {
      this.ventasSem += venta.cantidad;


      let fecha = moment(venta.fecha);


      let dia = fecha.day();


      if (dia == 0)
        dia = 6;
      else
        dia -= 1;


      this.mPorcentaje.dias[dia].agregarVenta(venta);
    }
  }

  static CrearSemana(data) {
    // console.log(data);
    let sem: SemanaModel = new SemanaModel('');
    if (data.id)
      sem.id = data.id;
    sem.tienda = data.tienda;
    sem.fecha = data.fecha;
    sem.semana = data.semana;
    sem.ventasSem = data.ventasSem;

    if (data.mPorcentaje.dias) {
      data.mPorcentaje.dias.map((d, i) => {

        let dia = sem.mPorcentaje.dias[i];
        dia.porcentaje = d.porcentaje;
        dia.precio = d.precio;
        if (d.fecha)
          dia.fecha = d.fecha;

        if (d.horas) {
          d.horas.map((h, j) => {
            let hora = dia.horas[j];
            hora.porcentaje = h.porcentaje;
            hora.precio = h.precio;

          });
        }


      });
    }
    let h = new HorarioModel();
    if (data.horario) {
      if (data.horario.dias) {
        data.horario.dias.map(ds => {
          h.dias.push(ds);
        });
      }
    }
    sem.estado = data.estado;
    // sem.fecha = data.fecha;
    sem.horario = h;

    return sem;
  }


}

export class MallaPorcentajeModel {
  public estado: number = 0;
  public dias: DiaModel[] = [];
  public semana: SemanaModel;

  constructor(sem: SemanaModel) {
    this.semana = sem;
  }
}

export class DiaModel {
  public semana: SemanaModel;
  public porcentaje: number = 0;
  public horas: HoraModel[] = [];
  public txtDia: string;
  public precio?: number = 0;
  public fecha: string = '';

  constructor(sem: SemanaModel) {
    this.semana = sem;
    for (let i = 0; i < 24; i++) {
      let hora = new HoraModel();
      hora.semana = this.semana;
      hora.dia = this;
      hora.txtHora = `${0 + i}:00`;
      this.horas.push(hora);

      let hora2 = HoraModel.Clone(hora);
      hora2.txtHora = `${0 + i}:30`;
      this.horas.push(hora2);
    }
  }

  inicializar() {
    if (this.precio != 0)
      this.porcentaje = this.precio / this.semana.ventasSem * 100;
  }

  inicializarPrecio() {
    if (this.porcentaje != 0)
      this.precio = this.semana.ventasSem * this.porcentaje / 100;
    else
      this.precio = 0;
  }


  agregarVenta(venta) {
    this.precio += venta.cantidad;
    let fecha = moment(venta.fecha);
    let hora = fecha.hour();
    let mins = fecha.minutes();

    // if (mins < 30)
    //   this.horas[hora * 2].precio += venta.cantidad;
    // else
    //   this.horas[(hora * 2) + 1].precio += venta.cantidad;

    this.horas[hora * 2].precio += venta.cantidad / 2;
    this.horas[(hora * 2) + 1].precio += venta.cantidad / 2;


  }
}

export class HoraModel {
  public txtHora: any;
  public dia: DiaModel;
  public semana: SemanaModel;
  public porcentaje: number = 0;
  public precio?: number = 0;

  inicializar() {
    if (this.dia.precio != 0)
      this.porcentaje = this.precio / this.dia.precio * 100;
  }

  inicializarPrecio() {
    if (this.porcentaje != 0)
      this.precio = this.dia.precio * this.porcentaje / 100;
    else
      this.precio = 0;
  }

  static Clone(hs: HoraModel) {
    let h = new HoraModel();
    h.txtHora = hs.txtHora;
    h.dia = hs.dia;
    h.semana = hs.semana;
    h.porcentaje = hs.porcentaje;
    h.precio = hs.precio;
    return h;
  }
}

export function devolverDiaSem(dia: number) {
  switch (dia) {
    case 0 :
      return 'Lunes';
    case 1:
      return 'Martes';
    case 2:
      return 'Miercoles';
    case 3:
      return 'Jueves';
    case 4:
      return 'Viernes';
    case 5:
      return 'Sabado';
    case 6:
      return 'Domingo';
    default:
      return '';
  }
}

export class HorarioModel {
  tienda: string;
  fecha: string;
  dias: DiasProgModel[] = [];
}

export class DiasProgModel {
  // esta opcion va a estar deprecada
  nombre: string;
  dia: string;
  horaInicio: string;
  horaCierre: string;
}
